import { DB_REF } from 'interface/database'
import store from 'store2'

export const localStorageSetting = (dbRef: DB_REF, value?: unknown) => {
  return store(dbRef, value)
}
